__turbopack_context__.v({
  "awayTeamBorder": "sportscard-module-scss-module__yGW1mG__awayTeamBorder",
  "borderBackground": "sportscard-module-scss-module__yGW1mG__borderBackground",
  "contentWrapper": "sportscard-module-scss-module__yGW1mG__contentWrapper",
  "homeTeamBorder": "sportscard-module-scss-module__yGW1mG__homeTeamBorder",
  "inCarousel": "sportscard-module-scss-module__yGW1mG__inCarousel",
  "listenLiveLink": "sportscard-module-scss-module__yGW1mG__listenLiveLink",
  "matchupChannels": "sportscard-module-scss-module__yGW1mG__matchupChannels",
  "matchupCol": "sportscard-module-scss-module__yGW1mG__matchupCol",
  "matchupDate": "sportscard-module-scss-module__yGW1mG__matchupDate",
  "matchupDay": "sportscard-module-scss-module__yGW1mG__matchupDay",
  "matchupIconAt": "sportscard-module-scss-module__yGW1mG__matchupIconAt",
  "matchupLogoGroup": "sportscard-module-scss-module__yGW1mG__matchupLogoGroup",
  "matchupRow": "sportscard-module-scss-module__yGW1mG__matchupRow",
  "matchupScheduleLink": "sportscard-module-scss-module__yGW1mG__matchupScheduleLink",
  "matchupTime": "sportscard-module-scss-module__yGW1mG__matchupTime",
  "moreInfo": "sportscard-module-scss-module__yGW1mG__moreInfo",
  "moreInfoActive": "sportscard-module-scss-module__yGW1mG__moreInfoActive",
  "moreInfoContent": "sportscard-module-scss-module__yGW1mG__moreInfoContent",
  "singleMatchup": "sportscard-module-scss-module__yGW1mG__singleMatchup",
  "sportMatchupCard": "sportscard-module-scss-module__yGW1mG__sportMatchupCard",
  "teamName": "sportscard-module-scss-module__yGW1mG__teamName",
});
